import React, { FC, ReactNode } from 'react';
import SelectLang from '../SelectLang';
import SelectOptions from '../SelectOptions';
import { HeaderContainer, DivContent } from './styles';

type HeaderProps = {
  children: ReactNode;
  hideItem: 'BUTTONS' | 'SELECTIONS' | 'BOTH';
  className?: string;
  isHomePage?: boolean;
}
const Header: FC<HeaderProps> = (props) => {
  const classes = `${props.hideItem !== 'SELECTIONS' ? 'hide' : 'show'} ${props.className}`;

  return <HeaderContainer className={props.className} isHomePage={props.isHomePage}>
    <DivContent className={classes}>
      {props.children}
    </DivContent>
    <DivContent className={props.hideItem !== 'BUTTONS' ? 'hide' : 'show'} isHomePage={props.isHomePage}>
      <SelectOptions />
      <SelectLang isLogin={false} />
    </DivContent>
  </HeaderContainer>;
};

export default Header;

